import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FaBed, FaUtensils, FaSpa, FaCalendarAlt, FaMapMarkerAlt, FaStar, FaChevronLeft, FaChevronRight,FaPlane } from 'react-icons/fa';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import rooms from '../data/rooms';

const Home = () => {
  const [checkIn, setCheckIn] = useState(null);
  const [checkOut, setCheckOut] = useState(null);
  const [guests, setGuests] = useState(1);
  const [roomType, setRoomType] = useState('');

  const highlights = [
    {
      icon: FaBed,
      title: 'Luxury Rooms',
      image: `${process.env.PUBLIC_URL}/assets/lux_rooms.png`,
      link: '/rooms'
    },
    {
      icon: FaUtensils,
      title: 'Fine Dining',
      image: `${process.env.PUBLIC_URL}/assets/restaurant.png`,
      link: '/gallery'
    },
    {
      icon: FaSpa,
      title: 'Adventure Packages',
      image: `${process.env.PUBLIC_URL}/assets/adventure.png`,
      link: '/attractions'
    },
    {
      icon: FaCalendarAlt,
      title: 'Tours Assistance',
      image: `${process.env.PUBLIC_URL}/assets/tours.png`,
      link: '/attractions'
    }
  ];

  const experiences = [
    { title: 'Paragliding', description: 'Soar above Pokhara\'s stunning landscapes' },
    { title: 'Lake Boating', description: 'Peaceful cruises on Phewa Lake' },
    { title: 'Trekking Tours', description: 'Guided adventures to Himalayan trails' }
  ];

  const testimonials = [
    {
      name: 'Humnath Acharya',
      image: 'https://picsum.photos/100/100?random=20',
      text: 'An unforgettable experience! The views, the service, everything was perfect.',
      rating: 5
    },
    {
      name: 'Hari Dhakal',
      image: 'https://picsum.photos/100/100?random=21',
      text: 'The hotel exceeded all our expectations. Truly a luxury retreat.',
      rating: 5
    },
    {
      name: 'Remy Collins',
      image: 'https://picsum.photos/100/100?random=22',
      text: 'From the moment we arrived, we felt welcomed and pampered.',
      rating: 5
    }
  ];

  const galleryImages = [
    `${process.env.PUBLIC_URL}/assets/g1.png`,
    `${process.env.PUBLIC_URL}/assets/lux_rooms.png`,
    `${process.env.PUBLIC_URL}/assets/story_bed.png`,
    `${process.env.PUBLIC_URL}/assets/restaurant.png`
  ];

  const testimonialSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 6000,
    arrows: false
  };

  const featuredRooms = rooms.slice(0, 4);

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <motion.section
        className="relative h-screen flex items-center justify-center text-center text-white overflow-hidden"
        style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/hero.png)`, backgroundSize: 'cover', backgroundPosition: 'center' }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.5 }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/70 to-black/80"></div>

        
        <motion.div
          className="absolute top-40 right-32 text-3xl text-accent/20"
          animate={{ y: [0, 15, 0], x: [0, 10, 0] }}
          transition={{ duration: 5, repeat: Infinity }}
        >
          <FaStar />
        </motion.div>
        <motion.div
          className="absolute bottom-32 left-32 text-2xl text-accent/25"
          animate={{ y: [0, -10, 0], rotate: [0, -5, 0] }}
          transition={{ duration: 3, repeat: Infinity }}
        >
          <FaSpa />
        </motion.div>

        <div className="relative z-10 max-w-6xl mx-auto px-4">
          <motion.h1
            className="text-5xl md:text-8xl font-serif font-bold mb-6 drop-shadow-2xl"
            initial={{ y: 100, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 1, delay: 0.2 }}
          >
            Experience Luxury in the Heart of Pokhara
          </motion.h1>
          <motion.p
            className="text-xl md:text-3xl mb-12 text-gray-200 drop-shadow-lg font-light"
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 1, delay: 0.5 }}
          >
            Where lake serenity meets Himalayan charm
          </motion.p>
          <motion.div
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 1, delay: 0.8 }}
          >
            <a
  href="https://www.booking.com/hotel/np/admire-pokhara-pvt-ltd.html?aid=2405612&label=brave_nonbrand_organic_trigger_f3f828ac-4c6a-4b54-8e46-e2779b841553&sid=cd36b88c5418b460034b77c1a1c04aa8&all_sr_blocks=467069401_150918546_2_42_0&checkin=2025-12-08&checkout=2025-12-09&dest_id=-1022488&dest_type=city&dist=0&group_adults=2&group_children=0&hapos=1&highlighted_blocks=467069401_150918546_2_42_0&hpos=1&matching_block_id=467069401_150918546_2_42_0&no_rooms=1&req_adults=2&req_children=0&req_children=0&room1=A%2CA&sb_price_type=total&sr_order=popularity&sr_pri_blocks=467069401_150918546_2_42_0__1031&srepoch=1765215188&srpvid=df5e7b67e45c01c5&type=total&ucfs=1&#RD467069403"
  target="_blank"
  rel="noopener noreferrer"
  className="bg-gradient-to-r from-accent via-accent to-accent hover:from-accent/90 hover:via-accent/95 hover:to-accent text-primary font-serif font-bold py-5 px-12 rounded-full text-xl transition-all duration-300 shadow-2xl hover:shadow-accent/25 transform hover:scale-110 inline-block"
>
  Book Now
</a>

          </motion.div>
        </div>
      </motion.section>

      {/* Quick Booking Strip */}
     

      {/* Highlights Section */}
      <section className="py-24 bg-gradient-to-br from-highlight to-background">
        <div className="max-w-7xl mx-auto px-4">
          <motion.div
            className="text-center mb-16"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
          >
            <h2 className="text-4xl md:text-5xl font-serif font-bold text-primary mb-4">Our Highlights</h2>
            <p className="text-xl text-secondary max-w-2xl mx-auto">Discover what makes Hotel Admire exceptional</p>
          </motion.div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {highlights.map((highlight, index) => (
              <motion.div
                key={index}
                className="group relative overflow-hidden rounded-2xl shadow-xl cursor-pointer"
                whileHover={{ y: -10 }}
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: index * 0.1 }}
              >
                <div className="relative h-64 overflow-hidden">
                  <img
                    src={highlight.image}
                    alt={highlight.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
                  <div className="absolute bottom-6 left-6 text-white">
                    <highlight.icon className="text-3xl mb-2 text-accent" />
                    <h3 className="text-xl font-serif font-bold mb-1">{highlight.title}</h3>
                    <p className="text-sm text-secondary">{highlight.description}</p>
                  </div>
                </div>
                <Link
                  to={highlight.link}
                  className="absolute inset-0"
                  aria-label={`Learn more about ${highlight.title}`}
                />
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* About Preview Section */}
      <section className="py-24 bg-background">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
            >
              <h2 className="text-4xl font-serif font-bold text-primary mb-6">A Sanctuary by the Lake</h2>
              <p className="text-lg text-secondary leading-relaxed mb-6">
                For over a decade, Hotel Admire has been welcoming discerning travelers seeking the perfect blend of luxury and serenity. Our lakeside location offers breathtaking views of Phewa Lake and the majestic Annapurna mountains.
              </p>
              <p className="text-lg text-secondary leading-relaxed mb-8">
                Every detail is thoughtfully curated to create an atmosphere of tranquility and elegance, where modern comfort meets traditional Nepali hospitality.
              </p>
              <Link
                to="/about"
                className="inline-block bg-primary hover:bg-primary/90 text-background font-serif font-semibold py-4 px-8 rounded-full transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105"
              >
                Discover Our Story
              </Link>
            </motion.div>
            <motion.div
              className="relative"
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
            >
              <div className="relative">
                <motion.img
                  src={`${process.env.PUBLIC_URL}/assets/story_room.png`}
                  alt="Hotel view"
                  className="w-full h-80 object-cover rounded-2xl shadow-2xl"
                  whileHover={{ scale: 1.02 }}
                  transition={{ duration: 0.3 }}
                />
                <motion.img
                  src={`${process.env.PUBLIC_URL}/assets/story_building.png`}
                  alt="Lake view"
                  className="absolute -bottom-8 -left-8 w-48 h-64 object-cover rounded-xl shadow-xl border-4 border-white"
                  whileHover={{ scale: 1.05, rotate: 2 }}
                  transition={{ duration: 0.3 }}
                />
                <motion.img
                  src={`${process.env.PUBLIC_URL}/assets/story_bed.png`}
                  alt="Mountain view"
                  className="absolute -top-8 -right-8 w-40 h-48 object-cover rounded-lg shadow-xl border-4 border-white"
                  whileHover={{ scale: 1.05, rotate: -2 }}
                  transition={{ duration: 0.3 }}
                />
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Featured Rooms Section */}
      <section className="py-24 bg-gradient-to-br from-highlight to-highlight">
        <div className="max-w-7xl mx-auto px-4">
          <motion.div
            className="text-center mb-16"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
          >
            <h2 className="text-4xl md:text-5xl font-serif font-bold text-primary mb-4">Featured Rooms</h2>
            <p className="text-xl text-secondary">Handpicked suites for an unforgettable stay</p>
          </motion.div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {featuredRooms.map((room, index) => (
              <motion.div
                key={room.id}
                className="bg-background rounded-2xl shadow-xl overflow-hidden group cursor-pointer"
                whileHover={{ y: -10 }}
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: index * 0.1 }}
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={room.image}
                    alt={room.name}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-all duration-300 flex items-center justify-center">
                    <span className="text-white text-lg font-semibold opacity-0 group-hover:opacity-100 transition-opacity">View Details</span>
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-serif font-bold text-primary mb-2">{room.name}</h3>
                  <p className="text-2xl font-bold text-accent mb-3">${room.price}<span className="text-sm font-normal text-secondary">/night</span></p>
                  <div className="flex flex-wrap gap-2 mb-4">
                    {room.amenities.slice(0, 3).map((amenity, idx) => (
                      <span key={idx} className="text-xs bg-highlight px-2 py-1 rounded-full text-secondary">{amenity}</span>
                    ))}
                  </div>
                  <Link
                    to={`/rooms/${room.id}`}
                    className="block text-center bg-accent hover:bg-accent/90 text-primary font-semibold py-3 px-6 rounded-lg transition-all duration-300 shadow-md hover:shadow-lg"
                  >
                    Book Now
                  </Link>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Experiences Section */}
      <motion.section
        className="py-24 bg-cover bg-center text-white relative"
        style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/fewa.png)` }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.5 }}
      >
        <div className="absolute inset-0 bg-black/60"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 text-center">
          <motion.h2
            className="text-4xl md:text-6xl font-serif font-bold mb-6"
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 1, delay: 0.2 }}
          >
            Beyond a Stay, We Offer Experiences
          </motion.h2>
          <motion.p
            className="text-xl mb-12 max-w-3xl mx-auto"
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 1, delay: 0.4 }}
          >
            Immerse yourself in the beauty and adventure of Pokhara with our curated experiences
          </motion.p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {experiences.map((exp, index) => (
              <motion.div
                key={index}
                className="bg-white/10 backdrop-blur-sm p-8 rounded-2xl"
                whileHover={{ scale: 1.05, backgroundColor: 'rgba(255,255,255,0.2)' }}
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: index * 0.2 }}
              >
                <h3 className="text-2xl font-serif font-bold mb-4">{exp.title}</h3>
                <p className="text-gray-200 leading-relaxed">{exp.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </motion.section>

      {/* Testimonials Section */}
      <section className="py-24 bg-gradient-to-br from-highlight to-background">
        <div className="max-w-6xl mx-auto px-4">
          <motion.div
            className="text-center mb-16"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
          >
            <h2 className="text-4xl md:text-5xl font-serif font-bold text-primary mb-4">What Our Guests Say</h2>
            <p className="text-xl text-secondary">Real experiences from our valued guests</p>
          </motion.div>
          <div className="bg-background p-8 rounded-3xl shadow-2xl">
            <Slider {...testimonialSettings}>
              {testimonials.map((testimonial, index) => (
                <div key={index} className="text-center px-8">
                  <div className="flex justify-center mb-6">
                    <img
                      src={testimonial.image}
                      alt={testimonial.name}
                      className="w-20 h-20 rounded-full object-cover border-4 border-accent"
                    />
                  </div>
                  <div className="flex justify-center mb-4">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <FaStar key={i} className="text-accent text-xl" />
                    ))}
                  </div>
                  <blockquote className="text-xl italic text-secondary mb-6 leading-relaxed max-w-3xl mx-auto">
                    "{testimonial.text}"
                  </blockquote>
                  <p className="text-lg font-serif font-bold text-primary">- {testimonial.name}</p>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </section>

      {/* Gallery Preview Section */}
      <section className="py-24 bg-background">
        <div className="max-w-7xl mx-auto px-4">
          <motion.div
            className="text-center mb-16"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
          >
            <h2 className="text-4xl md:text-5xl font-serif font-bold text-primary mb-4">Gallery</h2>
            <p className="text-xl text-secondary">A glimpse of the beauty that surrounds us</p>
          </motion.div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
            {galleryImages.map((img, index) => (
              <motion.div
                key={index}
                className="relative overflow-hidden rounded-2xl shadow-xl group cursor-pointer"
                whileHover={{ scale: 1.05 }}
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.8, delay: index * 0.1 }}
              >
                <img
                  src={img}
                  alt={`Gallery ${index + 1}`}
                  className="w-full h-64 object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-all duration-300 flex items-center justify-center">
                  <span className="text-white text-lg font-semibold opacity-0 group-hover:opacity-100 transition-opacity">View Gallery</span>
                </div>
              </motion.div>
            ))}
          </div>
          <div className="text-center">
            <Link
              to="/gallery"
              className="inline-block bg-primary hover:bg-primary/90 text-background font-serif font-bold py-4 px-8 rounded-full transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105"
            >
              View Full Gallery
            </Link>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="py-24 bg-gradient-to-br from-highlight to-background">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
            >
              <h2 className="text-4xl font-serif font-bold text-primary mb-6">Find Us</h2>
              <p className="text-lg text-secondary mb-6">
                Our strategic location offers easy access to all the region's attractions while providing the tranquility you seek.
              </p>
              <div className="space-y-4 mb-6">
                <div className="flex items-center">
                  <FaMapMarkerAlt className="text-accent mr-3 flex-shrink-0" />
                  <span className="text-secondary">Street no. 4, 46, 48 in route</span>
                </div>
                <div className="flex items-center">
                  <FaCalendarAlt className="text-accent mr-3 flex-shrink-0" />
                  <span className="text-secondary">5 min from Phewa Lake</span>
                </div>
                <div className="flex items-center">
                  <FaPlane className="text-accent mr-3 flex-shrink-0" />
                  <span className="text-secondary">30 min from Pokhara Airport</span>
                </div>
              </div>
              <Link
                to="https://maps.app.goo.gl/RyrAU8FH8u9JkUfb8"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-accent hover:bg-accent/90 text-primary font-serif font-semibold py-3 px-6 rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl"
              >
                Get Directions
              </Link>
            </motion.div>
            <motion.div
              className="relative"
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
            >
              <div className="aspect-w-16 aspect-h-9 rounded-2xl overflow-hidden shadow-2xl">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d219.74901583724397!2d83.9685645!3d28.207791!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39959503977ab6d7%3A0x40b40319432edf96!2sHotel%20Admire%20Pokhara%20Pvt.%20Ltd.!5e0!3m2!1sen!2snp!4v1759131018882!5m2!1sen!2snp"
                  width="400"
                  height="300"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Hotel Location"
                ></iframe>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      
    </div>
  );
};

export default Home;